/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const FACEBOOK_DM_WIDGET_TYPE = 'SEND_FACEBOOK_MESSAGE'
const FACEBOOK_RECURRING_CONSENT_DISPLAY_TYPE =
  'Send Facebook Recurring Consent'

const isFacebookRecurringConsentAction = R.propEq(
  'type',
  FACEBOOK_RECURRING_CONSENT_DISPLAY_TYPE
)

const convertFacebookRecurringConsentActionToWidgetAction = successAction => {
  const store = require('../../../../../../store')
  const { notificationFrequency } = store.default.getState().form.widget.values

  return R.applySpec({
    type: R.always(FACEBOOK_DM_WIDGET_TYPE),
    message: {
      message: {
        attachment: {
          type: R.always('template'),
          payload: {
            title: R.prop('recurringConsentTitle'),
            payload: R.always('username:${senderName}'),
            template_type: R.always('notification_messages'),
            image_url: R.prop('recurringConsentImageUrl'),
            notification_messages_reoptin: R.always('ENABLED'),
            notification_messages_frequency: R.always(notificationFrequency),
            notification_messages_timezone: R.always('Africa/Johannesburg')
          }
        }
      },
      recipient: {
        id: R.always('${senderId}')
      }
    }
  })(successAction)
}

export {
  isFacebookRecurringConsentAction,
  convertFacebookRecurringConsentActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/form-to-widget/facebook-recurring-consent.js